/**
 * Reminder utility functions and constants
 * Shared between ReminderSetupCard and any future reminder UI
 */

export const DEFAULT_REMINDER_DAYS = [true, true, true, true, true, false, false]; // Mon-Fri
export const DEFAULT_REMINDER_TIME = '09:00';

export const DAY_KEYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

/**
 * Generate time options for a dropdown (30-minute intervals)
 * @param {string} languageCode - User's native language code (e.g., 'en', 'fr')
 * @returns {{ value: string, label: string }[]} Array of time options
 */
export function getTimeOptions(languageCode) {
  const use12Hour = languageCode === 'en';

  return Array.from({ length: 48 }, (_, i) => {
    const hours = Math.floor(i / 2);
    const minutes = i % 2 === 0 ? '00' : '30';
    const value = `${String(hours).padStart(2, '0')}:${minutes}`;

    let label;
    if (use12Hour) {
      const period = hours < 12 ? 'AM' : 'PM';
      const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      label = `${displayHour}:${minutes} ${period}`;
    } else {
      label = value;
    }

    return { value, label };
  });
}

/**
 * Build a notification preferences object for saving
 * @param {boolean[]} reminderDays - Array of 7 booleans (Mon-Sun)
 * @param {string} reminderTime - Time string (e.g., "09:00")
 * @param {boolean} emailEnabled - Whether email reminders are enabled
 * @param {Object} calendarState - Calendar state { addedGoogle, addedOutlook, downloadedIcs }
 * @returns {Object} Preferences object ready for saveNotificationPreferences
 */
export function buildNotificationPreferences(reminderDays, reminderTime, emailEnabled, calendarState) {
  return {
    enabled: true,
    reminderDays,
    reminderTime,
    channels: {
      email: emailEnabled,
      calendar: calendarState,
    },
  };
}
